// Mirrors netlify/lib/ranks.mts — tier order must stay identical on both sides.
export const RANKS = ["member", "leader", "director", "exec", "senior"];

export const rankOf = (level) => RANKS.indexOf(level);

// Shown on the membership pass (all caps by design).
export const PASS_LABEL = {
  member: "ACTIVE MEMBER",
  leader: "TEAM LEADER",
  director: "DIRECTOR",
  exec: "EXECUTIVE STAFF",
  senior: "SENIOR — ALL ACCESS",
};

// Shown in prose.
export const LEVEL_LABEL = {
  member: "Active Member",
  leader: "Team Leader",
  director: "Director",
  exec: "Executive Staff",
  senior: "Senior — All Access",
};
